import { createClient } from '@supabase/supabase-js';

// Supabase project configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://qpalpdncuownwqknszro.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFwYWxwZG5jdW93bndxa25zenJvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA3MDExNjgsImV4cCI6MjA3NjI3NzE2OH0.uGBtK0X0Pkz-Hh6VVrof8S_Mx1_wCPT2HhVRj1uWL_E';

// Create and export Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper to check if current user is admin
export const checkIsAdmin = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return false;

    const { data: profile } = await supabase
      .from('profiles')
      .select('role')
      .eq('id', session.user.id)
      .single();

    return profile?.role === 'admin';
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};

// Helper to get user profile
export const getUserProfile = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }
};

// Helper to get current user profile
export const getCurrentUserProfile = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return null;

    return await getUserProfile(session.user.id);
  } catch (error) {
    console.error('Error fetching current user profile:', error);
    return null;
  }
};
